import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('partners'))
  },

}



// WEBPACK FOOTER //
// ./src/api/PartnerService.js